// The outbox on the phone: one IndexedDB object store (works in the PWA and in the APK's web view).
import type { OutboxItem, OutboxStore } from './outbox';

const DB = 'yakvender-offline';
const STORE = 'outbox';

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: 'id' });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
function run<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return open().then(
    (db) =>
      new Promise<T>((resolve, reject) => {
        const req = fn(db.transaction(STORE, mode).objectStore(STORE));
        req.onsuccess = () => resolve(req.result);
        req.onerror = () => reject(req.error);
      }),
  );
}

export class IdbStore implements OutboxStore {
  async all(): Promise<OutboxItem[]> {
    const list = (await run('readonly', (s) => s.getAll())) as OutboxItem[];
    return list.sort((a, b) => a.seq - b.seq);
  }
  async put(item: OutboxItem): Promise<void> {
    await run('readwrite', (s) => s.put(item));
  }
  async remove(id: string): Promise<void> {
    await run('readwrite', (s) => s.delete(id));
  }
}
